import React, {Component} from 'react'
import './BlogArticle.css';

class BlogArticle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      site_name: "cbusick.com"
    }
  }

  render() {
    return <div id='body' className='header-margin'>
      <div className='container-fluid'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/#">Home</a></li>
            <li className="breadcrumb-item"><a href="/#">Technology</a></li>
            <li className="breadcrumb-item active" aria-current="page">AWS Universe</li>
          </ol>
        </nav>

        <div className='row'>
          <div className='col-8'>
            <h1 className="text-center">AWS Universe</h1>
            <p>
            <span className='fancy-first-letter'>C</span>ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
            </p>
          </div>
          <div className='col-4'>
            <ul className="list-group">
              <li className="list-group-item">Cras justo odio</li>
              <li className="list-group-item">Dapibus ac facilisis in</li>
              <li className="list-group-item">Morbi leo risus</li>
              <li className="list-group-item">Porta ac consectetur ac</li>
              <li className="list-group-item">Vestibulum at eros</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  }
}

export default BlogArticle;
